// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EYox9","item":"styles_item__nFA_v"};